<section class="footer" #target>
  <div class="header-footer">
    <div class="container">
      <div class="row justify-content-between text-center text-md-left align-items-center">
        <!-- Payments -->
        <div class="col-md-5 mb-md-0 mb-4">
          <h4 class="title-footer">Payment</h4>
          <div class="payment d-flex justify-content-center gap-3 align-items-center">
            @defer(on viewport) {
            <!-- <div class="item" *ngFor="let img of paymentImages">
                <img [src]="img.src" [alt]="img.alt" class="img-fluid" width="106px" height="46px" />
              </div> -->
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#1565C0"
                d="M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z">
              </path>
              <path fill="#FFF"
                d="M15.186 19l-2.626 7.832c0 0-.667-3.313-.733-3.729-1.495-3.411-3.701-3.221-3.701-3.221L10.726 30v-.002h3.161L18.258 19H15.186zM17.689 30L20.56 30 22.296 19 19.389 19zM38.008 19h-3.021l-4.71 11h2.852l.588-1.571h3.596L37.619 30h2.613L38.008 19zM34.513 26.328l1.563-4.157.818 4.157H34.513zM26.369 22.206c0-.606.498-1.057 1.926-1.057.928 0 1.991.674 1.991.674l.466-2.309c0 0-1.358-.515-2.691-.515-3.019 0-4.576 1.444-4.576 3.272 0 3.306 3.979 2.853 3.979 4.551 0 .291-.231.964-1.888.964-1.662 0-2.759-.609-2.759-.609l-.495 2.216c0 0 1.063.606 3.117.606 2.059 0 4.915-1.54 4.915-3.752C30.354 23.586 26.369 23.394 26.369 22.206z">
              </path>
              <path fill="#FFC107"
                d="M12.212,24.945l-0.966-4.748c0,0-0.437-1.029-1.573-1.029c-1.136,0-4.44,0-4.44,0S10.894,20.84,12.212,24.945z">
              </path>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <linearGradient id="NgmlaCv2fU27PJOuiUvQVa_Sq0VNi1Afgmj_gr1" x1="20.375" x2="28.748" y1="1365.061"
                y2="1394.946" gradientTransform="translate(0 -1354)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#00b3ee"></stop>
                <stop offset="1" stop-color="#0082d8"></stop>
              </linearGradient>
              <path fill="url(#NgmlaCv2fU27PJOuiUvQVa_Sq0VNi1Afgmj_gr1)"
                d="M43.125,9H4.875C3.287,9,2,10.287,2,11.875v24.25C2,37.713,3.287,39,4.875,39h38.25	C44.713,39,46,37.713,46,36.125v-24.25C46,10.287,44.713,9,43.125,9z">
              </path>
              <circle cx="17.053" cy="24.053" r="10.053" fill="#cf1928"></circle>
              <linearGradient id="NgmlaCv2fU27PJOuiUvQVb_Sq0VNi1Afgmj_gr2" x1="20" x2="40.107" y1="24.053" y2="24.053"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#fede00"></stop>
                <stop offset="1" stop-color="#ffd000"></stop>
              </linearGradient>
              <circle cx="30.053" cy="24.053" r="10.053" fill="url(#NgmlaCv2fU27PJOuiUvQVb_Sq0VNi1Afgmj_gr2)"></circle>
              <path fill="#d97218"
                d="M20,24.053c0,3.072,1.382,5.818,3.553,7.662c2.172-1.844,3.553-4.59,3.553-7.662	s-1.382-5.818-3.553-7.662C21.382,18.235,20,20.981,20,24.053z">
              </path>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#d50000"
                d="M16.65,5.397c5.015-1.999,10.857-1.861,15.738,0.461l0.066,0.085l0.098-0.034	c3.704,1.776,6.852,4.706,8.857,8.303c1.718,3.062,2.614,6.591,2.526,10.105c-0.017,4.545-1.716,9.045-4.628,12.52	c-2.754,3.314-6.605,5.698-10.803,6.653c-4.209,0.971-8.738,0.552-12.677-1.237c-3.855-1.722-7.12-4.714-9.197-8.395	c-1.728-3.059-2.642-6.586-2.566-10.105c0.008-4.384,1.565-8.735,4.283-12.164C10.518,8.852,13.399,6.675,16.65,5.397z">
              </path>
              <path fill="#fff"
                d="M28.205,6.039c1.377-0.233,2.792-0.392,4.183-0.181l0.2,0.034l-0.134,0.051	c-1.294,0.371-2.545,0.951-3.554,1.86c-1.816,1.58-2.961,3.981-2.828,6.411c2.464,0.618,4.926,1.703,6.61,3.674	c1.764,2.013,2.402,4.806,2.206,7.431c-0.311,4.005-3.029,7.754-6.812,9.142c-2.521,0.94-5.409,0.952-7.898-0.102	c-2.583-1.064-4.727-3.127-5.944-5.642c-1.182-2.397-1.505-5.159-1.156-7.792c0.527-3.716,2.393-7.19,5.057-9.808	C20.912,8.505,24.466,6.745,28.205,6.039z">
              </path>
            </svg>

            } @placeholder {
            <p-skeleton width="100%" borderRadius="16px" height="7rem"></p-skeleton>
            }
          </div>
        </div>
        <!-- Social media icons -->
        <div class="col-md-5">
          <h4 class="title-footer">Social Media</h4>
          <div class="social d-flex align-items-center justify-content-center">
            <div class="item" *ngFor="let link of links">
              <a [href]="link?.url" target="_blank">
                <img loading="lazy" width="40" [src]="link?.icon" alt="{{ link.name }}" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-footer">
    <div class="container">
      <div class="row justify-content-around">
        <div class="col-md-4">
          <h4 class="title-footer bottom">
            {{ "footer.about.title" | translate }}
          </h4>
          <p class="desc-footer w-75">
            {{ "footer.about.aboutUs" | translate }}
          </p>
        </div>
        <div class="col-md-3">
          <h4 class="title-footer bottom">
            {{ "footer.quickLinks.title" | translate }}
          </h4>
          <ul class="list-unstyled">
            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/about">{{
                "footer.quickLinks.aboutUs" | translate }}</a>
            </li>
            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/contacts">{{
                "footer.quickLinks.contactUs" | translate }}</a>
            </li>

            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/privacy-policy">{{
                "footer.quickLinks.privacyPolicy" | translate }}</a>
            </li>
            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/refund-policy">{{
                "footer.quickLinks.refundPolicy" | translate }}</a>
            </li>
            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/terms-condition">{{
                "footer.quickLinks.termsConditions" | translate }}</a>
            </li>
            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/blogs">{{
                "footer.quickLinks.blogs" | translate }}</a>
            </li>
            <li>
              <a class="desc-footer link" (click)="scrollUp()" routerLink="/{{ lang }}/quick-links/FAQ">{{
                "footer.quickLinks.faq" | translate }}</a>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <h4 class="title-footer bottom">
            {{ "footer.contactUs.title" | translate }}
          </h4>
          <div class="d-flex flex-column">
            <div class="address-row mb-3">
              <h6 class="country fw-bold">Egypt</h6>
              <div class="address">
                12 Qawmiyah, Az Zagazig <br />
                <!-- +201013697554 -->
              </div>
            </div>
            <div class="address-row mb-3">
              <h6 class="country fw-bold">Saudi Arabia</h6>
              <div class="address">
                Mecca, Saudi Arabia <br />
                <!-- +966 56 744 6051 -->
              </div>
            </div>
            <div class="address-row mb-3">
              <h6 class="country fw-bold">United Arab Emirates</h6>
              <div class="address">
                Ras Al Khaimah, United Arab Emirates <br />
                <!-- +971 58 267 0902 -->
              </div>
            </div>
          </div>
        </div>
        <div class="trademark">
          <span routerLink="/en/quick-links/company-information" class="text-center">
            © 2025 Card4Games.com — Mo Nasr. All trademarks are property of
            their owners.</span>
        </div>
      </div>
    </div>
  </div>
</section>